import { render, staticRenderFns } from "./apiget_dlglq.vue?vue&type=template&id=eb5a87e8"
import script from "./apiget_dlglq.vue?vue&type=script&lang=js"
export * from "./apiget_dlglq.vue?vue&type=script&lang=js"
import style0 from "./apiget_dlglq.vue?vue&type=style&index=0&id=eb5a87e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports